import { Graph, Edge } from '@antv/x6'
import { useGraphRegister } from './createGraph'
import { ElMessage, ElMessageBox } from 'element-plus'
import { toRaw } from 'vue'
// import { deepAssign } from '@/utils/util'
import { NodeType, notDelCell } from '@/enums/flow'
import { deepMerge } from '@/utils/tools'

// @ts-ignore
export function createGraphRegister(
  id: string,
  {
    options,
    flowConfigData,
    currentNodeId
  }: {
    options: Graph
    flowConfigData: any
    currentNodeId: any
  },
  callback: () => void
) {
  const { graph, dnd, startDrag } = useGraphRegister(id, options, flowConfigData, currentNodeId)
  // 画布数据导出
  const exportJSON = async () => {
    return graph.value?.toJSON()
  }
  // 渲染画布
  const renderJson = (json: any) => {
    graph.value!.cleanHistory()
    graph.value!.fromJSON(json)
  }
  // 撤销
  const onUndo = () => {
    graph.value!.undo()
  }
  // 重做
  const onRedo = () => {
    graph.value!.redo()
  }
  const handleUpdate = (data: any, key: string, splitF: string = '.') => {
    const id = flowConfigData.value.nodeId
    const node = graph.value!.getCellById(id)
    const keys = key.split(splitF)
    if (!node) return
    const nodeData = node.getData() || {}
    let params: any = null
    for (let i = keys.length - 1; i >= 0; i--) {
      if (!params) {
        params = {}
        params[keys[i]] = data
      } else {
        const temp: any = {}
        temp[keys[i]] = params
        params = temp
      }
    }
    flowConfigData.value = deepMerge(flowConfigData.value, params, 'replace')
    node.setData(deepMerge(nodeData, params, 'replace'), { overwrite: true })
    console.log(
      toRaw(flowConfigData.value),
      deepMerge(nodeData, params, 'replace'),
      data,
      params,
      key
    )
  }
  const handleEdgeUpdate = (data: any, key: string) => {
    const id = flowConfigData.value.edgeId
    const node = graph.value!.getCellById(id) as Edge
    const nodeData = node.getData() || {}
    if (node) {
      flowConfigData.value = deepMerge(
        flowConfigData.value,
        {
          [key]: data
        },
        'replace'
      )
      if (key === 'name') {
        node.setLabelAt(0, data)
      }
      node.setData(deepMerge(nodeData, { [key]: data }, 'replace'), {
        overwrite: true
      })
    }
  }
  const handleUpdateEdgeById = (id: string, key: string, value: any) => {
    const node = graph.value!.getCellById(id) as Edge
    if (node) {
      if (key === 'name') {
        node.setLabelAt(0, value)
      }
      node.setData({ [key]: value })
      console.log(node.data.name, node.data.order)
    }
  }
  const handleSelectDel = () => {
    let selectCells = graph.value!.getSelectedCells()
    let allNodes = graph.value!.getNodes()
    let hasNotDel = false
    let hasBase = false
    // 过滤掉开始结束
    selectCells.some((node: any) => {
      const data = node.getData()
      // 开始结束不能删除
      if (notDelCell.includes(data.type)) {
        hasNotDel = true
      }
      if (data.isRoot) {
        hasBase = true
      }
    })
    if (hasNotDel) {
      ElMessage({
        message: '开始结束流程不可删除',
        type: 'warning'
      })
      return
    }
    if (hasBase) {
      ElMessage({
        message: '默认节点不可删除',
        type: 'warning'
      })
      return
    }
    // 基础节点不可删除
    selectCells = selectCells.filter((node: any) => {
      const { type = '' } = node.getData()
      return !notDelCell.includes(type)
    })
    // 判断node是否全等 全等不能删除
    const selectNodes = selectCells.filter((cell: any) => {
      const { type } = cell.getData()
      return !notDelCell.includes(type) && cell.isNode()
    })
    allNodes = allNodes.filter((cell: any) => {
      const { type } = cell.getData()
      return !notDelCell.includes(type) && cell.isNode()
    })
    if (selectNodes.length === allNodes.length) {
      ElMessage({
        message: '至少保留一个节点！',
        type: 'warning'
      })
    } else if (selectCells.length) {
      ElMessageBox.confirm('是否确认删除选中内容？', '提示', {
        type: 'warning'
      }).then(() => {
        graph.value!.removeCells(selectCells)
      })
    }
  }
  // 查找同一级的条件
  const getSameSourceEdge = (edge: any) => {
    const same: Edge[] = []
    if (edge) {
      const edges = graph.value.getEdges()
      const current = edges.find((e: any) => e.id === edge.edgeId)
      if (current && edges.length) {
        edges.forEach((e: any) => {
          const target = graph.value.getCellById(e.target.cell)
          const data = target && target.getData()
          // 来源节点相同，且目标节点不是同级节点
          if (e.source.cell === current.source.cell && data.type !== NodeType.PEER) {
            same.push(e)
          }
        })
      }
      return same.sort((a, b) => a?.data?.order - b?.data?.order)
    }
    return []
  }

  callback()
  return {
    graph,
    dnd,
    startDrag,
    exportJSON,
    renderJson,
    onUndo,
    onRedo,
    handleUpdate,
    handleEdgeUpdate,
    handleSelectDel,
    getSameSourceEdge,
    handleUpdateEdgeById
  }
}
